"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rallyTeamStencilDefinition = void 0;
const models_1 = require("../models");
const properties_1 = require("../properties");
exports.rallyTeamStencilDefinition = {
    view: {
        label: 'Rally Team',
        group: 'Persons & Groups',
        titleItems: ['title'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'teaser',
                    'car',
                    'story-content',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'url',
                            'uri-title',
                            'featured-media',
                            'featured-video',
                            'geolocation',
                            'logos',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'content-classification-terms',
                            'editorial-publish-date',
                            'standalone',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-rally-drivers',
                    'tag-rally-teams',
                ],
            },
        ],
        previewConfiguration: { hasFeatureCardPreview: true },
    },
    content: {
        [properties_1.carPropertyDefinition.name]: properties_1.carPropertyDefinition,
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.contentClassificationTermsPropertyDefinition.name]: properties_1.contentClassificationTermsPropertyDefinition,
        [properties_1.ctaContainerPropertyDefinition.name]: properties_1.ctaContainerPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.editorialPublishDatePropertyDefinition.name]: properties_1.editorialPublishDatePropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: {
            ...properties_1.featuredMediaPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
                {
                    name: 'stencils',
                    argument: ['image'],
                },
            ],
        },
        [properties_1.featuredVideoPropertyDefinition.name]: properties_1.featuredVideoPropertyDefinition,
        [properties_1.geolocationPropertyDefinition.name]: properties_1.geolocationPropertyDefinition,
        [properties_1.headerMediaPropertyDefinition.name]: properties_1.headerMediaPropertyDefinition,
        [properties_1.logosPropertyDefinition.name]: properties_1.logosPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        [properties_1.storyContentPropertyDefinition.name]: {
            ...properties_1.storyContentPropertyDefinition,
            constraints: [
                {
                    name: 'properties',
                    argument: [
                        'text',
                        'headline',
                        'quote',
                        'list',
                        'numbered-list',
                        'table',
                        'service-embed',
                        'image',
                        'image-gallery',
                        'video',
                        'audio',
                        'tip',
                        'fact',
                        'couple',
                        'interview',
                        'accordion',
                        'embedded-content',
                        'results-and-standings',
                        'legal-disclaimer',
                        'info-block-group',
                    ],
                },
            ],
        },
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagRallyDriversPropertyDefinition.name]: properties_1.tagRallyDriversPropertyDefinition,
        [properties_1.tagRallyTeamsPropertyDefinition.name]: properties_1.tagRallyTeamsPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: {
            ...properties_1.teaserPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
                {
                    name: 'maxLength',
                    argument: 200,
                },
            ],
        },
        [properties_1.titlePropertyDefinition.name]: {
            ...properties_1.titlePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'maxLength',
                    argument: 50,
                },
            ],
        },
        [properties_1.uriTitlePropertyDefinition.name]: {
            ...properties_1.uriTitlePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
                {
                    name: 'maxLength',
                    argument: 250,
                },
                {
                    name: 'pattern',
                    argument: '^[^#%?&/,]*$',
                },
            ],
        },
        [properties_1.urlPropertyDefinition.name]: properties_1.urlPropertyDefinition,
        [properties_1.serviceEmbedPropertyDefinition.name]: {
            ...properties_1.serviceEmbedPropertyDefinition,
            constraints: [
                {
                    name: 'providers',
                    argument: [...models_1.defaultServiceEmbedProviders, 'Rally TV'],
                },
            ],
        },
    },
    localizations: [],
    roles: [],
    spaces: ['erc', 'wrc'],
    name: 'rally-team',
};
const isRallyTeamStencil = (stencil) => {
    return stencil.name === exports.rallyTeamStencilDefinition.name;
};
//# sourceMappingURL=data:application/json;base64,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